export default __webpack_public_path__ + "fe5e9bab1847f8e48c016556dc885ffc.png";